import SavedSearch from "./saved-search";
export default SavedSearch;